import apiService from '../utils/apiService';

import {
  ADD_USER_ROLE,
  ADD_USER_ROLE_ERROR,
  ADD_USER_ROLE_START,
  UPDATE_USER_ROLE,
  UPDATE_USER_ROLE_ERROR,
  UPDATE_USER_ROLE_START,
  GET_USER_ROLE,
  GET_USER_ROLE_ERROR,
  GET_USER_ROLE_START,
  GET_USER_ROLE_LIST_PAGEABLE,
  GET_USER_ROLE_LIST_PAGEABLE_START,
  GET_USER_ROLE_LIST_PAGEABLE_ERROR,
  DELETE_USER_ROLE,
  DELETE_USER_ROLE_ERROR,
  DELETE_USER_ROLE_START,
  CLEAR_ERROR_USER_ROLE,
  GET_USER_ROLE_LIST,
  GET_USER_ROLE_LIST_ERROR,
  GET_USER_ROLE_LIST_START,
} from './types';

import {
  userRoleAddPath,
  userRoleUpdatePath,
  userRoleFindAllPath,
  userRoleFindByIdPath,
  userRoleDeletePath,
  userRoleFindAllPageablePath,
} from '../constants/apiEndpoints';
import { handleServerErrorMessage, handleServerSuccessMessage } from '../utils';
import { ModalForAddOrUpdateUserRole } from '../enums/UserRoleEnums';
import { ServerMessagesEnums } from '../enums/ServerMessagesEnums';

const clearError = () => {
  return {
    type: CLEAR_ERROR_USER_ROLE,
  };
};

const addUserRoleStart = () => {
  return {
    type: ADD_USER_ROLE_START,
  };
};
const addUserRoleSuccessfully = (data) => {
  return {
    type: ADD_USER_ROLE,
    payload: data,
  };
};
const addUserRoleUnsuccessfully = (err) => {
  return {
    type: ADD_USER_ROLE_ERROR,
    payload: err,
  };
};

const updateUserRoleStart = () => {
  return {
    type: UPDATE_USER_ROLE_START,
  };
};
const updateUserRoleSuccessfully = (data) => {
  return {
    type: UPDATE_USER_ROLE,
    payload: data,
  };
};
const updateUserRoleUnsuccessfully = (err) => {
  return {
    type: UPDATE_USER_ROLE_ERROR,
    payload: err,
  };
};

const getUserRoleStart = () => {
  return {
    type: GET_USER_ROLE_START,
  };
};
const getUserRoleSuccessfully = (data) => {
  return {
    type: GET_USER_ROLE,
    payload: data,
  };
};
const getUserRoleUnsuccessfully = (err) => {
  return {
    type: GET_USER_ROLE_ERROR,
    payload: err,
  };
};

const getUserRolePageableListStart = () => {
  return {
    type: GET_USER_ROLE_LIST_PAGEABLE_START,
  };
};

const getUserRolePageableListSuccessfully = (pageResponseData) => {
  return {
    type: GET_USER_ROLE_LIST_PAGEABLE,
    payload: pageResponseData,
  };
};

const getUserRoleListPageableUnsuccessfully = (err) => {
  return {
    type: GET_USER_ROLE_LIST_PAGEABLE_ERROR,
    payload: err,
  };
};

const deleteUserRoleStart = () => {
  return {
    type: DELETE_USER_ROLE_START,
  };
};
const deleteUserRoleSuccessfully = (id) => {
  return {
    type: DELETE_USER_ROLE,
    payload: id,
  };
};
const deleteUserRoleUnsuccessfully = (err) => {
  return {
    type: DELETE_USER_ROLE_ERROR,
    payload: err,
  };
};

const getUserRoleListStart = () => {
  return {
    type: GET_USER_ROLE_LIST_START,
  };
};
const getUserRoleListSuccessfully = (data) => {
  return {
    type: GET_USER_ROLE_LIST,
    payload: data,
  };
};
const getUserRoleListUnsuccessfully = (err) => {
  return {
    type: GET_USER_ROLE_LIST_ERROR,
    payload: err,
  };
};

export const createUserRole = (userRole, callback) => {
  return (dispatch) => {
    dispatch(addUserRoleStart());
    return apiService
      .post(userRoleAddPath(), userRole)
      .then((response) => {
        dispatch(addUserRoleSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateUserRole.saveSuccessMessage,
          userRole
        );
        callback();
      })
      .catch((err) => {
        dispatch(addUserRoleUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const updateUserRole = (userRole, callback) => {
  return (dispatch) => {
    dispatch(updateUserRoleStart());
    return apiService
      .post(userRoleUpdatePath(), userRole)
      .then((response) => {
        dispatch(updateUserRoleSuccessfully(response.data));
        handleServerSuccessMessage(
          ModalForAddOrUpdateUserRole.updateSuccessMessage,
          userRole
        );
        callback();
      })
      .catch((err) => {
        dispatch(updateUserRoleUnsuccessfully(err.response.data));
        handleServerErrorMessage(err?.response?.data?.message ? err?.response?.data?.message : err?.response?.data);
      });
  };
};

export const findAllUserRolesPageble = (pageNumber, pageSize, filters) => {
  return (dispatch) => {
    dispatch(getUserRolePageableListStart());
    return apiService
      .get(userRoleFindAllPageablePath(pageNumber, pageSize, filters))
      .then((response) => {
        const pageResponseData = {
          pageNumber: response.data.number,
          emptyList: response.data.empty,
          isFirstPage: response.data.first,
          isLastPage: response.data.last,
          list: response.data.content,
          totalPages: response.data.totalPages,
          totalElements: response.data.totalElements,
        };
        dispatch(getUserRolePageableListSuccessfully(pageResponseData));
      })
      .catch((err) => {
        dispatch(getUserRoleListPageableUnsuccessfully(err));
      });
  };
};

export const findUserRoleById = (id) => {
  return (dispatch) => {
    dispatch(getUserRoleStart());
    return apiService
      .get(userRoleFindByIdPath(id))
      .then((response) => {
        dispatch(getUserRoleSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getUserRoleUnsuccessfully(err));
      });
  };
};

export const deleteUserRole = (id) => {
  return (dispatch) => {
    dispatch(deleteUserRoleStart());
    return apiService
      .delete(userRoleDeletePath(id))
      .then(() => {
        dispatch(deleteUserRoleSuccessfully(id));
        handleServerSuccessMessage(
          ModalForAddOrUpdateUserRole.deleteSuccessMessage,
          { id }
        );
      })
      .catch((err) => {
        dispatch(deleteUserRoleUnsuccessfully(err.response.data));
        handleServerErrorMessage(
          err?.response?.status === 404
            ? ServerMessagesEnums.deleteErrorMessage404
            : err?.response?.data
        );
      });
  };
};

export const deleteErrorUserRole = () => {
  return (dispatch) => {
    dispatch(clearError());
  };
};

export const findAllUserRole = () => {
  return (dispatch) => {
    dispatch(getUserRoleListStart());
    return apiService
      .get(userRoleFindAllPath())
      .then((response) => {
        dispatch(getUserRoleListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getUserRoleListUnsuccessfully(err));
      });
  };
};
